"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import StackedContentComponent from "../ui/StackedContentComponent";
import { getGap, getPaddings } from "@/utils/theme-helper";

const SplitContentSectionComponent: React.FC<
  SectionProps<{
    layoutSizing?: "balanced";
    padding: string;
    gap: string;
    leftContent: any;
    rightContent: any;
  }> & {
    recaptchaSiteKey: string;
  }
> = ({ cmsSection, index, cmsData, app, recaptchaSiteKey }) => {
  const balanced = cmsSection.specifics.layoutSizing === "balanced";
  const getSizeClassName = () => {
    switch (cmsSection.ui?.contentWidth) {
      case "lg":
        return "max-w-screen-lg";
      case "xl":
        return "max-w-screen-xl";
      case "2xl":
        return "max-w-screen-2xl";
      case "4xl":
        return "max-w-screen-4xl";
      case "full":
        return "w-full";
      default:
        return "max-w-screen-xl";
    }
  };

  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "4xl",
        padding: "none",
      })}
      revealsByElement
    >
      <style>
        {`.section-${index}  {
          --left-content-width: ${cmsSection.specifics.leftContent.width};
          --right-content-width: ${cmsSection.specifics.rightContent.width};
              }`}
      </style>
      <div className={`flex flex-1 h-full justify-center section-${index}`}>
        <div className={balanced ? `${getSizeClassName()} w-full min-w-0` : `${getSizeClassName()} `}>
          {balanced && <style>{`@media(min-width:768px){.section-${index} [data-balanced-layout]{display:grid;grid-template-columns:minmax(0,${parseFloat(cmsSection.specifics.leftContent.width) || 50}fr) minmax(0,${parseFloat(cmsSection.specifics.rightContent.width) || 50}fr)}.section-${index} [data-balanced-layout]>div{min-width:0;width:100%}}`}</style>}
          <div data-balanced-layout={balanced || undefined}
            className={`flex md:flex-row h-full ${
              cmsSection.specifics?.leftContent.mobilePosition === "bottom"
                ? "flex-col-reverse"
                : "flex-col"
            } ${getPaddings(cmsSection.specifics.padding)} ${getGap(cmsSection.specifics.gap)}`}
          >
            <div
              className="h-full relative flex md:w-[var(--left-content-width)] w-full"
              style={{
                backgroundColor: cmsSection.specifics.leftContent.bgColor,
              }}
            >
              <StackedContentComponent
                cmsData={cmsData}
                config={cmsSection.specifics.leftContent}
                list="leftContent"
                index={index}
                app={app}
                cmsSection={cmsSection}
                recaptchaSiteKey={recaptchaSiteKey}
              />
            </div>
            <div
              className="h-full flex md:w-[var(--right-content-width)] w-full"
              style={{
                backgroundColor: cmsSection.specifics.rightContent.bgColor,
              }}
            >
              <StackedContentComponent
                cmsData={cmsData}
                config={cmsSection.specifics.rightContent}
                list="rightContent"
                index={index}
                app={app}
                cmsSection={cmsSection}
                recaptchaSiteKey={recaptchaSiteKey}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default SplitContentSectionComponent;
